import {
  GmailConnectRequest,
  PBRAuthResponse,
  PBRGmailAuthRequest,
} from '@playback-rewards/shared-libraries'
import { axiosBackendInstance } from '../axiosInstance'

export const generateBaseAuthLink = async (userOpts: unknown, signupAttribution = null) => {
  return axiosBackendInstance.post('/auth/v2/generate-link/base', {
    userOpts,
    state: signupAttribution,
  })
}

export const generateBaseUrlForSecondaryEmail = async () => {
  return axiosBackendInstance.get('/auth/v2/generate-link/secondary')
}

export const googleAuth = async (data: object) => {
  return axiosBackendInstance.post('/auth', data)
}

export const getUserProfileFromToken = async (accessToken: string) => {
  return axiosBackendInstance.get(`/auth/profile?token=${accessToken}`)
}

export const generateAuthLink = async (redirectUri: string, scopes: string[], userId = null) => {
  const params = new URLSearchParams({ scopes: scopes.join(',') })
  const userIdParam = userId ? `userId=${userId}` : ''
  const url = `/auth/generate-link?redirectUri=${redirectUri}&${params}&${userIdParam}`

  return axiosBackendInstance.get(url)
}

// TODO DEPRECATED CAN BE REMOVED ONCE AUTH UPDATES RELEASE
export const generateGoogleOauth = async (redirectUri: string, scopes: string[], userId = null) => {
  const params = new URLSearchParams({ scopes: scopes.join(',') })
  const userIdParam = userId ? `userId=${userId}` : ''
  const url = `/auth/generate-google-oauth?redirectUri=${redirectUri}&${params}&${userIdParam}`

  return axiosBackendInstance.get(url)
}

export const signupWithGmail = async (authReq: PBRGmailAuthRequest): Promise<PBRAuthResponse> => {
  return await axiosBackendInstance.post(`/api/v2/auth/signup/gmail`, authReq)
}

export const authorize = async (authReq: PBRGmailAuthRequest): Promise<PBRAuthResponse> => {
  return await axiosBackendInstance.post(`/api/v2/auth/authorize/gmail`, authReq)
}

export const connectGmail = async (
  connectGmailReq: GmailConnectRequest
): Promise<PBRAuthResponse> => {
  return await axiosBackendInstance.post(`/api/v2/auth/connect-gmail`, connectGmailReq)
}

export const closeGmailConnectModal = async (userId: string) => {
  return await axiosBackendInstance.put(`/api/v2/auth/modal/${userId}`)
}

export const generateAuthLinkPostClientRedirect = async (
  redirectUri: string,
  scopes: string[],
  signupAttribution: unknown,
  userId = null
) => {
  const url = `/auth/generate-link-client-redirect`

  return axiosBackendInstance.post(url, {
    redirectUri,
    scopes,
    state: signupAttribution,
    userId,
  })
}

export const generateAuthLinkPost = async (
  redirectUri: string,
  scopes: string[],
  signupAttribution: unknown,
  userId = null
) => {
  const url = `/auth/generate-link`

  return axiosBackendInstance.post(url, {
    redirectUri,
    scopes,
    state: signupAttribution,
    userId,
  })
}

export const getTokens = async (authRequest: unknown, provider: unknown) => {
  const url = `/auth/token`

  return axiosBackendInstance
    .post(url, {
      authRequest,
      provider,
    })
    .catch((err) => {
      throw err
    })
}

export const getTokensConnectGmail = async (authRequest: unknown, provider: unknown) => {
  const url = `/auth/two-step-create-account`

  return axiosBackendInstance
    .post(url, {
      authRequest,
      provider,
    })
    .catch((err) => {
      throw err
    })
}

export const handleLogin = async (data: object) => {
  const url = `/auth/login`

  return axiosBackendInstance.post(url, data).catch((err) => {
    throw err
  })
}

export const handleLogoutBackend = async () => {
  const url = `/auth/logout`

  return axiosBackendInstance.post(url).catch((err) => {
    throw err
  })
}
export const updateRefreshTokenState = async (userId: string) => {
  return axiosBackendInstance.put(`/auth/refresh-token/${userId}`)
}

export const connectSecondEmail = async () => {
  return axiosBackendInstance.get('/auth/gmail/second-email')
}

export const updateUserCountry = async (body: unknown) => {
  return axiosBackendInstance.put('/auth/select-country', body)
}

export const getAuthLinkWithScopes = async (email: string, signupAttr: string) => {
  return axiosBackendInstance.get(`/auth/v2/link/gmail?email=${email}&signupAttr=${signupAttr}`)
}

export const updateUserLastLoginData = async (data: unknown) => {
  return axiosBackendInstance.patch(`/auth/login-data`, data)
}
